import { mapGetters, mapMutations } from 'vuex';
import Multiselect from 'vue-multiselect'
import Datepicker from 'vuejs-datepicker';
import { required, requiredUnless, maxLength } from 'vuelidate/lib/validators'

export default {
    name: 'EditInsuranceReqRCA',

    components: {
        Datepicker,
        Multiselect,
    },

    props: {
        Id: {
            type: Number,
            default: 0
        },
    },

    data: () => {
        return {
            loading: true,
            //
            showValidityPeriodCustom: false,
            validityPeriodCustom: false,
            //validityPeriod: [6, 12],
            validityPeriods: [
                { value: 1, text: '1' },
                { value: 2, text: '2' },
                { value: 3, text: '3' },
                { value: 4, text: '4' },
                { value: 5, text: '5' },
                { value: 6, text: '6' },
                { value: 7, text: '7' },
                { value: 8, text: '8' },
                { value: 9, text: '9' },
                { value: 10, text: '10' },
                { value: 11, text: '11' },
                { value: 12, text: '12' }
            ],
            //
            orderVehicle: {
                StartDate: new Date(),
                EndDate: new Date(),
                Period: 12,
                PaymentsNo: 1,
                SelectedInsurers: '',
                Remarks: ''
            },

            vehicleOptions: {},
            //
            startDate: null,
            expirationDate: null,
            //
            insuranceCompanies: [],
            selectedInsuranceCompanies: [],
            //
            disabledDates: null
        }
    },
    validations: {
        vehicleOptions:
        {
            ValidityPeriod: {
                required,
                maxLength: maxLength(2)
            }
        },
        orderVehicle:
        {
            EndDate: requiredUnless('expirationDateIsOptional'),
            SelectedInsurers:
            {
                required
            }
        },
        selectedInsuranceCompanies: { 
            required 
        }

    },
    computed: {
        ...mapGetters(
            {
                // general
                orderTypeSettings: 'general/orderTypeSettings',
                typeSettings: 'general/typeSettings',

                // order
                order: 'order/order',
                orderLoaded: 'order/orderLoaded',
                orderEditable: 'order/orderEditable',
                orderVehicleOptions: 'order/vehicleOptions',
                vehicle: 'order/vehicle',
            }),
        //
        isValid() {
            return !this.$v.$anyError
        },
        //
        validityPeriodIsValid() {
            return !this.$v.vehicleOptions.ValidityPeriod.$anyError;
        },
        expirationDateIsInvalid() {
            return this.$v.orderVehicle.EndDate.$anyError;
        },
        selectedInsuranceCompaniesIsValid() {
            return !this.$v.orderVehicle.SelectedInsurers.$anyError
        },
        //
        expirationDateIsOptional() {
            return !this.validityPeriodCustom;
        }
    },

    created() {
        var orderType = 0;
        orderType = this.order.OrderTypeId;

        this.orderSettings = this.typeSettings(orderType);
        this.insuranceCompanies = this.orderSettings.JsonSettings.AvailableInsurers;

        // copy vehicle options
        this.vehicleOptions = JSON.parse(JSON.stringify(this.orderVehicleOptions));

        // copy editable fields from order
        this.orderVehicle.StartDate = this.order.StartDate;
        this.orderVehicle.EndDate = this.order.EndDate;
        this.orderVehicle.Period = this.order.Period;
        this.orderVehicle.PaymentsNo = this.order.PaymentsNo;
        this.orderVehicle.SelectedInsurers = this.order.SelectedInsurers;
        this.orderVehicle.Remarks = this.order.Remarks;

        //
        var disabledToDate = new Date();
        this.disabledDates = {
            to: disabledToDate
        };

        // Select all by default
        this.selectedInsuranceCompanies = this.insuranceCompanies.map(function (item) { return item.Code; });

        this.loading = false;
    },

    methods: {

        ...mapMutations({
            setVehicleOptions: 'order/setVehicleOptions',
            setVehicleOrderFields: 'order/setVehicleOrderFields',
            
        }),


        validate: function () {
            this.$v.$touch();
            this.$nextTick(() => this.findFirstError());

            return this.isValid;
        },
        chkState: function (val) {
            const field = this.getDescendantProp(this.$v, val);

            return !field.$dirty || !field.$invalid
        },
        //
        validityPeriodChanged: function (changed) {
            if (changed.length > 0)
                this.validityPeriodCustom = false;
        },
        validityPeriodCustomChanged: function (changed) {
            if (changed == true)
                this.vehicleOptions.ValidityPeriod = [];
        },

        selectedInsurersChanged: function (changed) {
            if (changed.length > 0)
                this.validityPeriodCustom = false;
        },

    },

    watch: {
        vehicleOptions: {
            handler: function (val, oldVal) {

                this.setVehicleOptions(val);
            },
            deep: true,
        },

        orderVehicle: {
            handler: function (val, oldVal) {
                if (!this.loading) {
                    this.setVehicleOrderFields(val);
                }
            },
            deep: true,
        },
        'vehicle.RegistrationType':{
            handler: function (val) {

                var disabledToDate = new Date();
                if (val == 2) /* 'In vederea inmatricularii' */ {
                    disabledToDate.setDate(disabledToDate.getDate() - 1);
                }
                this.disabledDates = {
                    to: disabledToDate
                };

                console.log('orderVehicle.RegistrationType.Code= ' + val);
            },
            deep: true,
        }
    },
}
